<template>
  <div
    id="testimonial-2"
    class="layout-pt-lg layout-pb-lg"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <div class="container">
      <div class="row">
        <div class="col-12 text-center">
          <div class="section-title mb-5">
            <div class="quote-icon mb-3">
              <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9.22209 0.589844C10.3251 2.52484 11.1001 4.43984 11.5491 6.33984C11.9971 8.23984 12.2221 10.1568 12.2221 12.0898C12.2221 14.3568 11.9251 16.5898 11.3341 18.7898C10.7441 20.9898 9.94309 23.1238 8.93409 25.1898C7.92509 27.2558 6.75409 29.2228 5.42109 31.0878C4.08709 32.9548 2.68709 34.7228 1.22109 36.3888L0.821094 35.9888C0.686094 35.8558 0.621094 35.6898 0.621094 35.4888C0.621094 35.4248 0.686094 35.2568 0.821094 34.9888C3.75409 30.9888 5.98709 27.2898 7.52109 23.8888C9.05409 20.4888 9.82109 17.1228 9.82109 13.7888C9.82109 11.6558 9.58709 9.83884 9.12109 8.33884C8.65409 6.83884 7.95409 5.18884 7.02109 3.38884C6.75409 2.85584 6.62109 2.52384 6.62109 2.38884C6.62109 2.05584 6.82109 1.78884 7.22109 1.58884L9.22209 0.589844ZM33.1211 0.589844C34.2251 2.52484 35.0001 4.43984 35.4481 6.33984C35.8961 8.23984 36.1211 10.1568 36.1211 12.0898C36.1211 14.3568 35.8381 16.5898 35.2711 18.7898C34.7051 20.9898 33.9211 23.1238 32.9211 25.1898C31.9211 27.2558 30.7531 29.2228 29.4211 31.0878C28.0871 32.9548 26.6871 34.7228 25.2211 36.3888L24.8221 35.9888C24.6871 35.8558 24.6211 35.6898 24.6211 35.4888C24.6211 35.4248 24.6871 35.2568 24.8221 34.9888C27.7211 30.9888 29.9311 27.2898 31.4471 23.8888C32.9631 20.4888 33.7211 17.1228 33.7211 13.7888C33.7211 11.6558 33.4871 9.83884 33.0211 8.33884C32.5541 6.83884 31.8541 5.18884 30.9211 3.38884C30.6531 2.85584 30.5211 2.52384 30.5211 2.38884C30.5211 2.05584 30.7211 1.78884 31.1211 1.58884L33.1211 0.589844Z"
                  fill="#BFA87E"
                />
              </svg>
            </div>
            <h2 class="testimonial-title" :style="`color: var(--c-${vars.titleColor})`">
              {{ vars.titleText }}
            </h2>
          </div>
        </div>
      </div>

      <div class="tw-relative tw-flex tw-flex-col tw-items-center">
        <div
          @click="slidePrev"
          v-if="canPaginateBack"
          class="d-none d-lg-block arrow-button tw-absolute tw-left-4 tw-top-12 tw-z-10  tw-cursor-pointer"
        >
          <svg width="61" height="27" viewBox="0 0 61 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10.4697 14.0303C10.1768 13.7374 10.1768 13.2626 10.4697 12.9697L15.2426 8.1967C15.5355 7.90381 16.0104 7.90381 16.3033 8.1967C16.5962 8.48959 16.5962 8.96447 16.3033 9.25736L12.0607 13.5L16.3033 17.7426C16.5962 18.0355 16.5962 18.5104 16.3033 18.8033C16.0104 19.0962 15.5355 19.0962 15.2426 18.8033L10.4697 14.0303ZM61 14.25H11V12.75H61V14.25Z"
              fill="#BFA87E"
            />
            <circle
              cx="13.5"
              cy="13.5"
              r="13"
              transform="matrix(-1 0 0 1 27 0)"
              stroke="#BFA87E"
              stroke-opacity="0.5"
            />
          </svg>
        </div>

        <div class="content-container tw-w-full lg:tw-px-14">
          <div
            @touchstart="handleTouchStart"
            @touchend="handleTouchEnd"
            @mousedown="handleMouseDown"
            @mouseup="handleMouseUp"
          >
            <div class="swiper-wrapper" ref="swiperWrapper">
              <div v-for="(review, index) in reviews" :key="`testimonial-review-${index}`" class="swiper-slide">
                <div class="single-testimonial-item">
                  <div class="testimonial-header mb-4">
                    <div class="d-flex align-items-center justify-content-center">
                      <div class="d-flex align-items-center me-3">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_219_1763)">
                            <path
                              d="M8.35909 0.789921C5.96112 1.6218 3.89311 3.20073 2.45882 5.2948C1.02454 7.38887 0.299573 9.88769 0.390418 12.4242C0.481264 14.9608 1.38313 17.4013 2.96355 19.3874C4.54396 21.3735 6.71962 22.8005 9.17096 23.4587C11.1583 23.9715 13.2405 23.994 15.2385 23.5243C17.0484 23.1177 18.7218 22.2481 20.0947 21.0005C21.5236 19.6624 22.5608 17.9602 23.0947 16.0768C23.6751 14.0287 23.7783 11.8748 23.3966 9.78055H12.2366V14.4099H18.6997C18.5705 15.1483 18.2937 15.853 17.8859 16.4819C17.478 17.1107 16.9474 17.6509 16.326 18.0699C15.5367 18.592 14.6471 18.9432 13.7141 19.1012C12.7784 19.2752 11.8186 19.2752 10.8828 19.1012C9.93444 18.9051 9.03727 18.5137 8.24846 17.9518C6.98124 17.0548 6.02973 15.7804 5.52971 14.3105C5.02124 12.8132 5.02124 11.1898 5.52971 9.69242C5.88564 8.64283 6.47403 7.68717 7.25096 6.8968C8.14007 5.9757 9.26571 5.31729 10.5044 4.99381C11.743 4.67034 13.0469 4.69429 14.2728 5.06305C15.2305 5.35703 16.1063 5.87068 16.8303 6.56305C17.5591 5.83805 18.2866 5.11117 19.0128 4.38242C19.3878 3.99055 19.7966 3.61742 20.166 3.21617C19.0608 2.18769 17.7635 1.3874 16.3485 0.861171C13.7717 -0.0744733 10.9522 -0.0996178 8.35909 0.789921Z"
                              fill="#4285F4"
                            />
                            <path
                              d="M8.35875 0.790832C10.9516 -0.0993112 13.7711 -0.0748285 16.3481 0.860207C17.7634 1.39001 19.0601 2.19415 20.1637 3.22646C19.7887 3.62771 19.3931 4.00271 19.0106 4.39271C18.2831 5.11896 17.5562 5.84271 16.83 6.56396C16.106 5.87159 15.2302 5.35794 14.2725 5.06396C13.047 4.69391 11.7432 4.66857 10.5042 4.99072C9.26516 5.31288 8.13883 5.97007 7.24875 6.89021C6.47181 7.68059 5.88342 8.63624 5.5275 9.68583L1.64062 6.67646C3.03189 3.91751 5.44078 1.80713 8.35875 0.790832Z"
                              fill="#EA4335"
                            />
                            <path
                              d="M0.611401 9.65703C0.820316 8.62164 1.16716 7.61896 1.64265 6.67578L5.52953 9.69266C5.02105 11.19 5.02105 12.8134 5.52953 14.3108C4.23453 15.3108 2.9389 16.3158 1.64265 17.3258C0.452308 14.9564 0.0892746 12.2567 0.611401 9.65703Z"
                              fill="#FBBC05"
                            />
                            <path
                              d="M12.2391 9.77734H23.3991C23.7809 11.8716 23.6776 14.0255 23.0972 16.0736C22.5633 17.957 21.5261 19.6592 20.0972 20.9973C18.8429 20.0186 17.5829 19.0473 16.3285 18.0686C16.9504 17.6491 17.4812 17.1084 17.8891 16.4788C18.297 15.8493 18.5735 15.1439 18.7022 14.4048H12.2391C12.2372 12.8636 12.2391 11.3205 12.2391 9.77734Z"
                              fill="#4285F4"
                            />
                            <path
                              d="M1.64062 17.3236C2.93687 16.3236 4.2325 15.3186 5.5275 14.3086C6.02851 15.779 6.98138 17.0534 8.25 17.9498C9.04127 18.5091 9.94037 18.8973 10.89 19.0898C11.8257 19.2638 12.7855 19.2638 13.7213 19.0898C14.6542 18.9319 15.5439 18.5806 16.3331 18.0586C17.5875 19.0373 18.8475 20.0086 20.1019 20.9873C18.7292 22.2356 17.0558 23.1059 15.2456 23.513C13.2476 23.9827 11.1655 23.9601 9.17813 23.4473C7.60632 23.0277 6.13814 22.2878 4.86563 21.2742C3.51874 20.2049 2.41867 18.8573 1.64062 17.3236Z"
                              fill="#34A853"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_219_1763">
                              <rect width="24" height="24" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <div class="d-flex">
                        <svg
                          v-for="n in 5"
                          :key="`star-${n}`"
                          width="20"
                          height="19"
                          viewBox="0 0 20 19"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="me-1"
                        >
                          <path
                            d="M3.825 19L5.45 11.975L0 7.25L7.2 6.625L10 0L12.8 6.625L20 7.25L14.55 11.975L16.175 19L10 15.275L3.825 19Z"
                            fill="#D4A574"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>

                  <div class="testimonial-content">
                    <p
                      class="testimonial-text !tw-max-h-[210px] tw-min-h-[200px] tw-overflow-auto"
                      v-html="review.content"
                    ></p>
                    <div class="testimonial-author">
                      <h5 class="author-name">{{ review.person_name }}</h5>
                    </div>
                    <div class="d-lg-none tw-mt-8 tw-flex tw-items-center tw-justify-center tw-gap-4">
                      <div v-if="canPaginateBack" @click="slidePrev" class="arrow-button tw-cursor-pointer">
                        <svg width="61" height="27" viewBox="0 0 61 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M10.4697 14.0303C10.1768 13.7374 10.1768 13.2626 10.4697 12.9697L15.2426 8.1967C15.5355 7.90381 16.0104 7.90381 16.3033 8.1967C16.5962 8.48959 16.5962 8.96447 16.3033 9.25736L12.0607 13.5L16.3033 17.7426C16.5962 18.0355 16.5962 18.5104 16.3033 18.8033C16.0104 19.0962 15.5355 19.0962 15.2426 18.8033L10.4697 14.0303ZM61 14.25H11V12.75H61V14.25Z"
                            fill="#BFA87E"
                          />
                          <circle
                            cx="13.5"
                            cy="13.5"
                            r="13"
                            transform="matrix(-1 0 0 1 27 0)"
                            stroke="#BFA87E"
                            stroke-opacity="0.5"
                          />
                        </svg>
                      </div>
                      <div v-if="canPaginateNext" @click="slideNext" class="arrow-button tw-cursor-pointer">
                        <svg width="61" height="27" viewBox="0 0 61 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M50.5303 14.0303C50.8232 13.7374 50.8232 13.2626 50.5303 12.9697L45.7574 8.1967C45.4645 7.90381 44.9896 7.90381 44.6967 8.1967C44.4038 8.48959 44.4038 8.96447 44.6967 9.25736L48.9393 13.5L44.6967 17.7426C44.4038 18.0355 44.4038 18.5104 44.6967 18.8033C44.9896 19.0962 45.4645 19.0962 45.7574 18.8033L50.5303 14.0303ZM0 14.25H50V12.75H0V14.25Z"
                            fill="#BFA87E"
                          />
                          <circle cx="47.5" cy="13.5" r="13" stroke="#BFA87E" stroke-opacity="0.5" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          @click="slideNext"
          v-if="canPaginateNext"
          class="d-none d-lg-block arrow-button tw-absolute tw-right-4 tw-top-12 tw-z-10  tw-cursor-pointer"
        >
          <svg width="61" height="27" viewBox="0 0 61 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M50.5303 14.0303C50.8232 13.7374 50.8232 13.2626 50.5303 12.9697L45.7574 8.1967C45.4645 7.90381 44.9896 7.90381 44.6967 8.1967C44.4038 8.48959 44.4038 8.96447 44.6967 9.25736L48.9393 13.5L44.6967 17.7426C44.4038 18.0355 44.4038 18.5104 44.6967 18.8033C44.9896 19.0962 45.4645 19.0962 45.7574 18.8033L50.5303 14.0303ZM0 14.25H50V12.75H0V14.25Z"
              fill="#BFA87E"
            />
            <circle cx="47.5" cy="13.5" r="13" stroke="#BFA87E" stroke-opacity="0.5" />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineComponent({
  name: 'Theme9GoogleReview',
  mixins: [ComponentMixin],
  data() {
    return {
      reviews: [] as any[],
      currentSlide: 0,
      // DEĞİŞİKLİK: Swipe/drag işlemleri için yeni data property'leri
      touchStartX: 0,
    };
  },
  computed: {
    canPaginateBack(): boolean {
      return this.currentSlide > 0;
    },
    canPaginateNext(): boolean {
      return this.reviews.length > 1 && this.currentSlide < this.reviews.length - 1;
    },
  },
  created() {
    const parsed = (this as any).parseFormV2(this.vars.googleReviews);
    this.reviews = parsed?.reviews?.filter((r: any) => r.content?.trim()) || [];
  },
  mounted() {
    this.updateSliderPosition();
  },
  methods: {
    slideNext() {
      if (this.canPaginateNext) {
        this.currentSlide++;
        this.updateSliderPosition();
      }
    },
    slidePrev() {
      if (this.canPaginateBack) {
        this.currentSlide--;
        this.updateSliderPosition();
      }
    },
    updateSliderPosition() {
      const wrapper = this.$refs.swiperWrapper as HTMLElement;
      if (wrapper) {
        const translateX = -this.currentSlide * 100;
        wrapper.style.transform = `translateX(${translateX}%)`;
      }
    },

    // --- DEĞİŞİKLİK: Swipe ve Drag için yeni metodlar ---

    // Mouse Events for Desktop
    handleMouseDown(event: MouseEvent) {
      this.touchStartX = event.clientX;
    },
    handleMouseUp(event: MouseEvent) {
      const touchEndX = event.clientX;
      this.handleSwipe(touchEndX);
    },

    // Touch Events for Mobile
    handleTouchStart(event: TouchEvent) {
      this.touchStartX = event.touches[0].clientX;
    },
    handleTouchEnd(event: TouchEvent) {
      const touchEndX = event.changedTouches[0].clientX;
      this.handleSwipe(touchEndX);
    },

    // Swipe Logic
    handleSwipe(touchEndX: number) {
      const swipeThreshold = 50; // Minimum swipe distance in pixels
      const difference = this.touchStartX - touchEndX;

      if (Math.abs(difference) > swipeThreshold) {
        if (difference > 0) {
          // Swiped Left
          this.slideNext();
        } else {
          // Swiped Right
          this.slidePrev();
        }
      }
    },
  },
});
</script>

<style scoped>
.quote-icon {
  display: flex;
  justify-content: center;
  align-items: center;
}

.swiper-wrapper {
  display: flex;
  transition: transform 0.4s ease-in-out;
}

.swiper-slide {
  flex: 0 0 100%;
  box-sizing: border-box;
  padding: 0 15px;
}

.testimonial-content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.testimonial-text {
  margin-bottom: 30px;
  text-align: center;
  max-width: 80%;
  margin-left: auto;
  margin-right: auto;
}

.arrow-button {
  transition: all 0.3s ease;
}

.arrow-button svg circle {
  transition: stroke-opacity 0.3s ease;
}

.arrow-button:hover svg circle {
  stroke-opacity: 1;
}

.arrow-button:hover svg path {
  fill: #d4a574;
}

@media (max-width: 1024px) {
  .testimonial-title {
    font-size: 2rem;
  }
}

@media (max-width: 768px) {
  .testimonial-section {
    padding: 60px 0;
  }

  .content-container {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .swiper-slide {
    padding: 0 5px;
  }
}

@media (max-width: 480px) {
  .arrow-button svg {
    width: 50px;
    height: 22px;
  }
}
</style>
